(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["airline-compatibility-drawer"]) return;
  try {
    
  (() => {
    if (customElements.get('airline-compatibility')) return;

    class AirlineCompatibility extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('x-drawer');
        this.rows = Array.from(this.querySelectorAll('[data-airline-row]'));
        this.search = this.querySelector('[data-airline-search]');
        this.toggle = this.querySelector('[data-airline-toggle]');
        this.empty = this.querySelector('[data-airline-empty]');
        this.counts = this.querySelectorAll('[data-airline-count]');
        this.productWrap = this.querySelector('[data-airline-product]');
        this.productImage = this.querySelector('[data-airline-product-image]');
        this.productTitle = this.querySelector('[data-airline-product-title]');
        this.productSubtitle = this.querySelector('[data-airline-product-subtitle]');
        this.productDimensions = this.querySelector('[data-airline-product-dimensions]');
        this.labelCompatible = this.dataset.labelCompatible || '';
        this.labelIncompatible = this.dataset.labelIncompatible || '';

        this.rows.forEach((row) => {
          row.searchKey = this.normalize(row.dataset.name || '');
          row.statusEl = row.querySelector('[data-airline-status]');
        });

        if (!this.drawer) return;

        this.drawer.addEventListener('dialog:before-show', (event) => this.populate(event.detail.activator));

        if (this.search) {
          this.search.addEventListener('input', () => this.filter());
        }

        if (this.toggle) {
          this.toggle.addEventListener('change', () => this.filter());
        }
      }

      populate(activator) {
        if (!activator) return;

        const data = activator.dataset;
        const handles = new Set((data.airlineHandles || '').split(',').filter(Boolean));

        this.rows.forEach((row) => {
          const compatible = handles.has(row.dataset.handle);
          row.classList.toggle('is-compatible', compatible);
          row.classList.toggle('is-incompatible', !compatible);
          if (row.statusEl) {
            row.statusEl.textContent = compatible ? this.labelCompatible : this.labelIncompatible;
          }
        });

        this.counts.forEach((el) => {
          el.textContent = data.airlineCount || String(handles.size);
        });

        this.setText(this.productTitle, data.productTitle);
        this.setText(this.productSubtitle, data.productSubtitle);
        this.setText(this.productDimensions, data.productDimensions);

        if (this.productImage) {
          if (data.productImage) {
            this.productImage.src = data.productImage;
            this.productImage.alt = data.productTitle || '';
          } else {
            this.productImage.removeAttribute('src');
          }
        }

        if (this.productWrap) {
          this.productWrap.hidden = !(data.productTitle || data.productImage);
        }

        if (this.search) this.search.value = '';
        if (this.toggle) this.toggle.checked = true;
        this.filter();
      }

      setText(el, value) {
        if (!el) return;
        el.textContent = value || '';
        el.hidden = !value;
      }

      normalize(value) {
        return value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }

      filter() {
        const query = this.search ? this.normalize(this.search.value.trim()) : '';
        const compatibleOnly = this.toggle ? this.toggle.checked : false;
        let visible = 0;

        this.rows.forEach((row) => {
          const matchesText = !query || (row.searchKey || '').includes(query);
          const matchesCompatible = !compatibleOnly || row.classList.contains('is-compatible');
          const show = matchesText && matchesCompatible;
          row.hidden = !show;
          if (show) visible += 1;
        });

        if (this.empty) this.empty.hidden = visible !== 0;
      }
    }

    customElements.define('airline-compatibility', AirlineCompatibility);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capsule"] && !Shopify.designMode) return;
  try {
    
  class CapsuleCarousel extends HTMLElement {
    #index = 0;
    #count = 0;
    #items = [];
    #titles = [];
    #button = null;
    #buttonLabel = null;
    #toggle = null;
    #timer = null;
    #pauseTimer = null;
    #autoplaySeconds = 0;
    #busy = false;
    #centerWidth = 0;
    #hovering = false;
    #paused = false;

    connectedCallback() {
      this.#count = Number(this.dataset.slideCount);
      this.#items = [...this.querySelectorAll('[js-gallery-item]')];
      this.#titles = [...this.querySelectorAll('[js-title]')];
      this.#button = this.querySelector('[js-button]');
      this.#buttonLabel =
        this.#button?.querySelector('[js-button-content]') ?? this.#button;
      this.#toggle = this.querySelector('[js-autoplay-toggle]');

      if (!this.#items.length) return;

      this.#index = this.#count > 1 ? this.#count : 0;
      this.#applySlots(true);
      this.#applyMeta();

      if (this.#count <= 1) return;

      this.#autoplaySeconds = Number(this.dataset.autoplay);
      this.#paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#syncToggle();
      this.#startAutoplay();

      this.#toggle?.addEventListener('click', () => {
        this.#paused = !this.#paused;
        this.#syncToggle();
        if (this.#paused) this.#stopAutoplay();
        else this.#startAutoplay();
      });

      // Hover pause covers the whole component, CTA included: the button label
      // and href swap with the active slide, so it must not move under the cursor.
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (this.dataset.pauseOnHover === 'true' && this.#autoplaySeconds > 0) {
        this.addEventListener('mouseenter', () => {
          if (!canHover.matches) return;
          this.#hovering = true;
          this.#stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.#hovering = false;
          this.#startAutoplay();
        });
      }

      this.addEventListener('click', (event) => {
        const item = event.target.closest('[js-gallery-item]');
        if (!item) return;
        const target = this.#items.indexOf(item);
        if (target === -1 || target === this.#index) return;
        this.#slideTo(target);
        this.#pauseAutoplay();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.#items.findIndex(
          (item) => item.dataset.blockId === event.detail.blockId,
        );
        if (index === -1) return;

        this.#index = index;
        this.#applySlots(event.detail.load);
        this.#applyMeta();
      });
    }

    disconnectedCallback() {
      this.#stopAutoplay();
    }

    #syncToggle() {
      this.#toggle?.setAttribute('aria-pressed', String(this.#paused));
    }

    #startAutoplay() {
      if (this.#autoplaySeconds <= 0) return;
      if (this.#paused || this.#hovering) return;
      this.#stopAutoplay();
      this.#timer = window.setInterval(
        () => this.#next(),
        this.#autoplaySeconds * 1000,
      );
    }

    #stopAutoplay() {
      if (this.#timer) window.clearInterval(this.#timer);
      this.#timer = null;
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
      this.#pauseTimer = null;
    }

    #pauseAutoplay(ms = Math.max(this.#autoplaySeconds * 2000, 5000)) {
      if (!this.#autoplaySeconds) return;
      this.#stopAutoplay();
      this.#pauseTimer = window.setTimeout(() => {
        this.#pauseTimer = null;
        this.#startAutoplay();
      }, ms);
    }

    #applySlots(skipTransition = false) {
      this.#centerWidth =
        this.#items[this.#index]?.offsetWidth || this.#centerWidth || 450;

      if (skipTransition) this.classList.add('is-instant');

      this.#items.forEach((item, i) => {
        this.#setSlot(item, i - this.#index, skipTransition);
      });

      if (skipTransition) {
        void this.offsetWidth;
        this.classList.remove('is-instant');
      }
    }

    #setSlot(item, offset, skipTransition) {
      const ratio = 231 / 450;
      const width = this.#centerWidth;
      const gap = (width * (1 + ratio)) / 2;
      const side = width * ratio;
      const abs = Math.abs(offset);

      let pos = 0;
      if (offset > 0) pos = gap + (offset - 1) * side;
      else if (offset < 0) pos = -(gap + (abs - 1) * side);

      const scale = offset === 0 ? 1 : ratio;

      if (skipTransition) item.classList.add('is-instant');

      item.dataset.slot = abs > 2 ? 'edge' : String(offset);
      item.classList.toggle('is-active', offset === 0);
      item.style.transform = `translate(calc(-50% + ${pos}px), -50%) scale(${scale})`;
      item.style.zIndex = offset === 0 ? 3 : Math.max(1, 3 - abs);

      if (skipTransition) {
        void item.offsetWidth;
        item.classList.remove('is-instant');
      }
    }

    #applyMeta() {
      const slideIndex = this.#index % this.#count;

      this.#titles.forEach((title, i) => {
        title.classList.toggle('is-active', i === slideIndex);
      });

      const active = this.#items[this.#index];
      if (!active || !this.#button) return;

      const url = active.dataset.buttonUrl;
      const label = active.dataset.buttonLabel;

      if (url) {
        this.#button.href = url;
      } else {
        this.#button.removeAttribute('href');
      }

      if (label && this.#buttonLabel) {
        this.#buttonLabel.textContent = label;
      }
    }

    #completeSlide() {
      if (!this.#busy) return;

      if (this.#index < this.#count) {
        this.#index += this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      } else if (this.#index >= 2 * this.#count) {
        this.#index -= this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      }

      this.#busy = false;
    }

    #slideTo(target) {
      if (this.#busy || this.#count <= 1 || target === this.#index) return;
      this.#busy = true;
      this.#stepToward(target);
    }

    #stepToward(target) {
      this.#index += target > this.#index ? 1 : -1;
      this.#applySlots(false);
      this.#applyMeta();

      const done =
        this.#index === target
          ? () => this.#completeSlide()
          : () => {
              if (!this.#busy) return;
              this.#stepToward(target);
            };

      const active = this.#items[this.#index];
      let called = false;
      const once = () => {
        if (called) return;
        called = true;
        done();
      };

      active?.addEventListener('transitionend', once, { once: true });
      window.setTimeout(once, 650);
    }

    #next() {
      this.#slideTo(this.#index + 1);
    }
  }

  if (!window.customElements.get('capsule-carousel')) {
    window.customElements.define('capsule-carousel', CapsuleCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('category-grid')) {
    class CategoryGrid extends HTMLElement {
      connectedCallback() {
        const links = this.querySelectorAll('.category-grid__link');

        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            if (window.matchMedia('(hover: hover)').matches) return;

            if (!link.classList.contains('is-active')) {
              event.preventDefault();
              links.forEach((item) => item.classList.remove('is-active'));
              link.classList.add('is-active');
            }
          });
        });
      }
    }

    window.customElements.define('category-grid', CategoryGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('collection-navigation')) {
    class CollectionNavigation extends HTMLElement {
      connectedCallback() {
        const active = this.querySelector('.is-active')?.closest('li');
        if (!active) return;

        const containerBleed = parseFloat(getComputedStyle(active.parentElement).marginLeft) || 0;

        active.parentElement.scrollTo({
          left: active.getBoundingClientRect().left + containerBleed,
          behavior: 'smooth'
        });
      }
    }

    window.customElements.define('collection-navigation', CollectionNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-carousel"] && !Shopify.designMode) return;
  try {
    
  class EditorialCarousel extends HTMLElement {
    #index = 0;
    #count = 0;
    #items = [];
    #button = null;
    #buttonLabel = null;
    #timer = null;
    #pauseTimer = null;
    #autoplaySeconds = 0;
    #busy = false;
    #centerWidth = 0;

    connectedCallback() {
      this.#count = Number(this.dataset.slideCount);
      this.#items = [...this.querySelectorAll('[js-item]')];
      this.#button = this.querySelector('[js-button]');
      this.#buttonLabel =
        this.#button?.querySelector('[js-button-content]') ?? this.#button;

      if (!this.#items.length) return;

      this.#index = this.#count > 1 ? this.#count : 0;
      this.#applySlots(true);
      this.#applyMeta();
      this.classList.add('is-ready');

      if (this.#count <= 1) return;

      this.#autoplaySeconds = Number(this.dataset.autoplay);
      if (this.#autoplaySeconds > 0) this.#startAutoplay();

      this.addEventListener('click', (event) => {
        const item = event.target.closest('[js-item]');
        if (!item) return;
        const target = this.#items.indexOf(item);
        if (target === -1 || target === this.#index) return;
        this.#slideTo(target);
        this.#pauseAutoplay();
      });

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.#items.findIndex(
          (item) => item.dataset.blockId === event.detail.blockId,
        );
        if (index === -1) return;

        this.#index = index;
        this.#applySlots(event.detail.load);
        this.#applyMeta();
      });

      window.addEventListener('resize', () => this.#applySlots(true));
    }

    disconnectedCallback() {
      if (this.#timer) window.clearInterval(this.#timer);
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
    }

    #startAutoplay() {
      this.#timer = window.setInterval(
        () => this.#next(),
        this.#autoplaySeconds * 1000,
      );
    }

    #pauseAutoplay(ms = 3000) {
      if (!this.#autoplaySeconds) return;
      if (this.#timer) window.clearInterval(this.#timer);
      this.#timer = null;
      if (this.#pauseTimer) window.clearTimeout(this.#pauseTimer);
      this.#pauseTimer = window.setTimeout(() => {
        this.#pauseTimer = null;
        this.#startAutoplay();
      }, ms);
    }

    #applySlots(skipTransition = false) {
      if (skipTransition) this.classList.add('is-instant');

      // Pass 1: set the active state first. The active slot uses the center
      // dimensions, so this must land before we measure its width — otherwise
      // (on mobile, where sides use a smaller explicit width) the center would
      // still report the side width and the slots would overlap.
      this.#items.forEach((item, i) => {
        item.classList.toggle('is-active', i === this.#index);
      });

      // Measure the (now correctly sized) center slot once. Only trust the
      // measurement on instant passes (load / settle), where widths have
      // snapped; during an animated slide the width is mid-transition, so
      // reuse the cached value to keep the gap stable.
      if (skipTransition) {
        this.#centerWidth = this.#items[this.#index]?.offsetWidth || this.#centerWidth;
      }
      const width = this.#centerWidth || this.#items[this.#index]?.offsetWidth || 462;
      const styles = window.getComputedStyle(this);
      const scale = parseFloat(styles.getPropertyValue('--ec-side-scale')) || 0.6;
      const gapRatio =
        parseFloat(styles.getPropertyValue('--ec-gap-ratio')) || 0.35;

      const gap = width * gapRatio;
      const firstOffset = (width * (1 + scale)) / 2 + gap;
      const sideStep = width * scale + gap;

      // Pass 2: position every slot.
      this.#items.forEach((item, i) => {
        const offset = i - this.#index;
        const abs = Math.abs(offset);

        let pos = 0;
        if (offset > 0) pos = firstOffset + (offset - 1) * sideStep;
        else if (offset < 0) pos = -(firstOffset + (abs - 1) * sideStep);

        item.style.setProperty('--ec-pos', `${pos}px`);
        item.style.zIndex = offset === 0 ? 3 : Math.max(1, 3 - abs);
      });

      if (skipTransition) {
        void this.offsetWidth;
        this.classList.remove('is-instant');
      }
    }

    #applyMeta() {
      const active = this.#items[this.#index];
      if (!active || !this.#button) return;

      const url = active.dataset.buttonUrl;
      const label = active.dataset.buttonLabel;

      if (url) {
        this.#button.href = url;
      } else {
        this.#button.removeAttribute('href');
      }

      if (label && this.#buttonLabel) {
        this.#buttonLabel.textContent = label;
      }
    }

    #completeSlide() {
      if (!this.#busy) return;

      if (this.#index < this.#count) {
        this.#index += this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      } else if (this.#index >= 2 * this.#count) {
        this.#index -= this.#count;
        this.#applySlots(true);
        this.#applyMeta();
      }

      this.#busy = false;
    }

    #slideTo(target) {
      if (this.#busy || this.#count <= 1 || target === this.#index) return;
      this.#busy = true;
      this.#stepToward(target);
    }

    #stepToward(target) {
      this.#index += target > this.#index ? 1 : -1;
      this.#applySlots(false);
      this.#applyMeta();

      const done =
        this.#index === target
          ? () => this.#completeSlide()
          : () => {
              if (!this.#busy) return;
              this.#stepToward(target);
            };

      const active = this.#items[this.#index];
      let called = false;
      const once = () => {
        if (called) return;
        called = true;
        done();
      };

      active?.addEventListener('transitionend', once, { once: true });
      window.setTimeout(once, 650);
    }

    #next() {
      this.#slideTo(this.#index + 1);
    }
  }

  if (!window.customElements.get('editorial-carousel')) {
    window.customElements.define('editorial-carousel', EditorialCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-section')) {
      return;
    }

    class HeroSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.wireCardLink();
        this.initCardAlignment();

        if (
          !this.hasAttribute('scroll-animate') ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        this.initElements();
        this.attachEvents();
        this.update();
      }

      initCardAlignment() {
        this.cardAlignMedia = window.matchMedia('(min-width: 1000px)');
        this.alignCard = this.alignCard.bind(this);

        const scheduleAlign = () => requestAnimationFrame(this.alignCard);
        this.cardAlignObserver = new ResizeObserver(scheduleAlign);
        const inner = this.querySelector('.hero__content-inner');
        const card = this.querySelector('.hero__product-card');
        if (inner) this.cardAlignObserver.observe(inner);
        if (card) this.cardAlignObserver.observe(card);

        this.cardAlignMediaListener = scheduleAlign;
        this.cardAlignMedia.addEventListener(
          'change',
          this.cardAlignMediaListener,
        );
        window.addEventListener('load', scheduleAlign);
        this.alignCard();
      }

      alignCard() {
        const card = this.querySelector('.hero__product-card');
        const anchor =
          this.querySelector('.hero__content-inner .button') ||
          this.querySelector('.hero__content-inner');
        if (!card || !anchor) return;

        if (!this.cardAlignMedia.matches) {
          card.style.removeProperty('--hero-card-align-shift');
          card.removeAttribute('data-align-ready');
          return;
        }

        const anchorRect = anchor.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const currentShift =
          parseFloat(card.style.getPropertyValue('--hero-card-align-shift')) ||
          0;
        const anchorCenter = anchorRect.top + anchorRect.height / 2;
        const cardCenter = cardRect.top + cardRect.height / 2;
        const shift = currentShift + (anchorCenter - cardCenter);

        if (Math.abs(shift - currentShift) >= 0.5) {
          card.style.setProperty('--hero-card-align-shift', `${shift}px`);
        }
        card.setAttribute('data-align-ready', '');
      }

      wireCardLink() {
        const box = this.querySelector('.hero__box');
        if (!box || box.querySelector('.hero__card-link')) return;

        const button = this.querySelector('.hero__content .button[href]');
        if (!button) return;

        const href = button.getAttribute('href');
        if (!href || href === '#') return;

        const link = document.createElement('a');
        link.className = 'hero__card-link';
        link.href = href;
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
        if (button.target) {
          link.target = button.target;
          if (button.rel) link.rel = button.rel;
        }

        const media = box.querySelector('.hero__media');
        if (media && media.nextSibling) {
          box.insertBefore(link, media.nextSibling);
        } else {
          box.appendChild(link);
        }
      }

      disconnectedCallback() {
        this.detachEvents();

        if (this.cardAlignObserver) {
          this.cardAlignObserver.disconnect();
          this.cardAlignObserver = null;
        }
        if (this.cardAlignMedia && this.cardAlignMediaListener) {
          this.cardAlignMedia.removeEventListener(
            'change',
            this.cardAlignMediaListener,
          );
        }
      }

      initElements() {
        this.frame = this.querySelector('.hero__inner');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateScrollRange();
      }

      updateScrollRange() {
        this.scrollRange = window.innerHeight * 0.1;
      }

      attachEvents() {
        this.onScroll = this.update.bind(this);
        this.onResize = this.debounce(() => {
          this.updateScrollRange();
          this.update();
        }, 200);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      detachEvents() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
        }

        if (this.onResize) {
          window.removeEventListener('resize', this.onResize);
        }
      }

      getSpacing() {
        const isMobile = this.mobileQuery.matches;
        const prefix = isMobile ? 'mobile' : 'desktop';

        return {
          left: Number(this.dataset[prefix + 'Left'] ?? 0),
          right: Number(this.dataset[prefix + 'Right'] ?? 0),
          top: isMobile ? Number(this.dataset[prefix + 'Top'] ?? 0) : 40,
          bottom: Number(this.dataset[prefix + 'Bottom'] ?? 0),
        };
      }

      update() {
        if (!this.frame) {
          return;
        }

        const { left, right, top, bottom } = this.getSpacing();
        const progress = Math.min(window.scrollY / this.scrollRange, 1);
        const invertedProgress = 1 - progress;

        this.frame.style.paddingTop = `${top * invertedProgress}px`;
        this.frame.style.paddingBottom = `${bottom * invertedProgress}px`;
        this.frame.style.paddingLeft = `${left * invertedProgress}px`;
        this.frame.style.paddingRight = `${right * invertedProgress}px`;
      }

      debounce(fn, wait) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define('hero-section', HeroSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (!customElements.get('read-more-text')) {
      customElements.define(
        'read-more-text',
        class extends HTMLElement {
          connectedCallback() {
            this.content = this.querySelector('.read-more__content');
            this.toggle = this.querySelector('.read-more__toggle');

            if (!this.content || !this.toggle) {
              return;
            }

            this.moreLabel = this.toggle.querySelector('[data-more]');
            this.lessLabel = this.toggle.querySelector('[data-less]');

            requestAnimationFrame(() => this.updateOverflow());
            this.resizeObserver = new ResizeObserver(() =>
              this.updateOverflow(),
            );
            this.resizeObserver.observe(this.content);

            this.toggle.addEventListener('click', () => {
              if (this.hasAttribute('data-scroll-to-description-tab')) {
                this.scrollToDescriptionTab();
              } else {
                this.toggleExpanded();
              }
            });
          }

          scrollToDescriptionTab() {
            const target = document.querySelector('.js-description-target');
            if (!target) {
              this.toggleExpanded();
              return;
            }

            const details = target.querySelector('details');
            if (details && !details.open) {
              details.open = true;
            }

            const headerOffset =
              parseInt(
                getComputedStyle(document.documentElement).getPropertyValue(
                  '--header-height',
                ),
              ) || 0;
            const rect = target.getBoundingClientRect();
            const scrollTop = window.scrollY + rect.top - headerOffset - 16;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
          }

          disconnectedCallback() {
            if (this.resizeObserver) {
              this.resizeObserver.disconnect();
            }
          }

          updateOverflow() {
            if (this.hasAttribute('data-expanded')) {
              return;
            }

            const overflows =
              this.content.scrollHeight > this.content.clientHeight + 1;

            this.toggle.hidden = !overflows;
          }

          toggleExpanded() {
            if (this.hasAttribute('data-expanded')) {
              this.collapse();
            } else {
              this.expand();
            }
          }

          expand() {
            this.style.setProperty(
              '--read-more-full-height',
              this.content.scrollHeight + 'px',
            );
            this.setAttribute('data-expanded', '');
            this.setLabels(true);

            this.content.addEventListener(
              'transitionend',
              () => {
                if (this.hasAttribute('data-expanded')) {
                  this.style.setProperty('--read-more-full-height', 'none');
                }
              },
              { once: true },
            );
          }

          collapse() {
            this.style.setProperty(
              '--read-more-full-height',
              this.content.scrollHeight + 'px',
            );

            requestAnimationFrame(() => {
              this.removeAttribute('data-expanded');
              this.setLabels(false);
            });
          }

          setLabels(expanded) {
            if (this.moreLabel) {
              this.moreLabel.hidden = expanded;
            }

            if (this.lessLabel) {
              this.lessLabel.hidden = !expanded;
            }
          }
        },
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["push-category"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('slider-categories')) return;

    class SliderCategories extends HTMLElement {
      static cardSelector = '.category__card';
      static itemSelector = '.category__item';
      static sliderSelector = '.categories__slider';
      static positionClasses = ['is-prev', 'is-next', 'is-before', 'is-after'];
      static mobileBreakpoint = 1299;

      constructor() {
        super();

        this.flickity = null;
        this.pendingFrame = null;
        this.appliedShifts = new WeakMap();
        this.onResize = this.debounce(() => this.syncToViewport(), 200);
      }

      connectedCallback() {
        this.syncToViewport();

        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);

        this.destroySlider();
      }

      syncToViewport() {
        const blockCount = parseInt(this.dataset.blockCount);

        if (blockCount <= 1) {
          return;
        }

        const isMobile = window.innerWidth <= SliderCategories.mobileBreakpoint;

        if (isMobile && !this.flickity) {
          this.createSlider();
        } else if (!isMobile && this.flickity) {
          this.destroySlider();
        }
      }

      createSlider() {
        if (typeof Flickity === 'undefined') {
          window.addEventListener('load', () => this.syncToViewport(), { once: true });

          return;
        }

        this.flickity = new Flickity(this.querySelector(SliderCategories.sliderSelector), {
          cellAlign: 'center',
          contain: false,
          draggable: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          initialIndex: parseInt(this.dataset.initialIndex, 10),
        });

        this.measureStaticLayout();

        this.flickity.on('resize', () => {
          this.measureStaticLayout();

          this.render();
        });

        this.flickity.on('scroll', () => this.scheduleRender());

        this.flickity.on('settle', () => {
          if (this.pendingFrame !== null) {
            cancelAnimationFrame(this.pendingFrame);

            this.pendingFrame = null;
          }

          this.render();
        });

        this.render();
      }

      destroySlider() {
        if (this.pendingFrame !== null) {
          cancelAnimationFrame(this.pendingFrame);

          this.pendingFrame = null;
        }

        if (this.flickity) {
          this.flickity.destroy();

          this.flickity = null;
        }

        this.clearComputedStyles();
      }

      clearComputedStyles() {
        this.querySelectorAll(SliderCategories.itemSelector).forEach((item) => {
          item.style.left = '';
          item.classList.remove(...SliderCategories.positionClasses);

          const card = item.querySelector(SliderCategories.cardSelector);

          if (card) {
            card.style.transform = '';
          }
        });

        this.appliedShifts = new WeakMap();
      }

      scheduleRender() {
        if (this.pendingFrame !== null) {
          return;
        }

        this.pendingFrame = requestAnimationFrame(() => {
          this.pendingFrame = null;

          this.render();
        });
      }

      measureStaticLayout() {
        const rootStyles = getComputedStyle(this);
        const readNumber = (customProperty, fallback) => {
          const value = parseFloat(rootStyles.getPropertyValue(customProperty));

          return Number.isFinite(value) ? value : fallback;
        };

        this.config = {
          scaleMin: readNumber('--category-scale-min', 0.52),
          scaleMax: readNumber('--category-scale-max', 1),
          falloff: readNumber('--category-scale-falloff', 2),
        };

        this.flickity.cells.forEach((cell) => {
          cell.element.style.left = '';
        });

        this.appliedShifts = new WeakMap();

        this.itemMetrics = this.flickity.cells.map((cell) => {
          const element = cell.element;
          const rect = element.getBoundingClientRect();
          const itemStyles = getComputedStyle(element);
          const horizontalMargin = parseFloat(itemStyles.marginLeft) + parseFloat(itemStyles.marginRight);

          return { width: rect.width, horizontalMargin };
        });
      }

      render() {
        if (!this.flickity) {
          return;
        }

        const { scaleMin, scaleMax, falloff } = this.config;
        const containerRect = this.getBoundingClientRect();
        const containerCenter = containerRect.left + containerRect.width / 2;

        const items = this.flickity.cells.map((cell, index) => {
          const element = cell.element;
          const rect = element.getBoundingClientRect();
          const appliedShift = this.appliedShifts.get(element) || 0;
          const center = rect.left + rect.width / 2 - appliedShift;
          const offset = center - containerCenter;
          const { width, horizontalMargin } = this.itemMetrics[index];

          return { element, offset, width, horizontalMargin };
        });

        items.sort((first, second) => first.offset - second.offset);

        const fadeDistance = (items[0] ? items[0].width : 0) * falloff || 1;

        items.forEach((item) => {
          const distanceRatio = Math.min(Math.abs(item.offset) / fadeDistance, 1);

          item.scale = scaleMax - (scaleMax - scaleMin) * distanceRatio;
        });

        const centeredIndex = items.reduce(
          (closest, item, index) =>
            Math.abs(item.offset) < Math.abs(items[closest].offset) ? index : closest,
          0,
        );

        this.applyScaleAndClasses(items, centeredIndex);
        this.applyPositions(items);
      }

      applyScaleAndClasses(items, centeredIndex) {
        items.forEach((item, index) => {
          item.element.querySelector(SliderCategories.cardSelector).style.transform = `scale(${item.scale})`;
          item.element.classList.remove(...SliderCategories.positionClasses);

          if (index < centeredIndex) {
            item.element.classList.add('is-before');

            if (index === centeredIndex - 1) {
              item.element.classList.add('is-prev');
            }
          } else if (index > centeredIndex) {
            item.element.classList.add('is-after');

            if (index === centeredIndex + 1) {
              item.element.classList.add('is-next');
            }
          }
        });
      }

      applyPositions(items) {
        const gapBetween = (left, right) =>
          (left.width * left.scale) / 2 +
          (right.width * right.scale) / 2 +
          left.horizontalMargin / 2 +
          right.horizontalMargin / 2;

        const chainPositions = new Array(items.length);

        chainPositions[0] = 0;

        for (let index = 1; index < items.length; index++) {
          chainPositions[index] =
            chainPositions[index - 1] + gapBetween(items[index - 1], items[index]);
        }

        const anchor = this.anchorAtCenter(items, chainPositions);

        items.forEach((item, index) => {
          const shift = chainPositions[index] - anchor - item.offset;

          item.element.style.left = `${shift}px`;

          this.appliedShifts.set(item.element, shift);
        });
      }

      anchorAtCenter(items, chainPositions) {
        let lowerIndex = null;
        let upperIndex = null;

        for (let index = 0; index < items.length; index++) {
          if (items[index].offset <= 0) {
            lowerIndex = index;
          }

          if (items[index].offset >= 0 && upperIndex === null) {
            upperIndex = index;
          }
        }

        if (lowerIndex !== null && upperIndex !== null && lowerIndex !== upperIndex) {
          const lowerOffset = items[lowerIndex].offset;
          const upperOffset = items[upperIndex].offset;
          const ratio = (0 - lowerOffset) / (upperOffset - lowerOffset);

          return (
            chainPositions[lowerIndex] +
            ratio * (chainPositions[upperIndex] - chainPositions[lowerIndex])
          );
        }

        const nearestIndex = lowerIndex !== null ? lowerIndex : upperIndex;

        return chainPositions[nearestIndex] - items[nearestIndex].offset;
      }

      debounce(fn, wait) {
        let timer;

        return (...args) => {
          clearTimeout(timer);

          timer = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define('slider-categories', SliderCategories);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  /*
   * Le dimensionnement des cartes est entièrement en CSS (variables lues par le
   * widget Join, voir la feuille de style). Le JS se limite à :
   *  - attendre le montage du widget (shadow DOM asynchrone, aucun événement émis),
   *  - masquer ses flèches natives et brancher celles du thème sur sa liste,
   *  - tenir le compteur et l'état des flèches à jour,
   *  - fournir la largeur du wrapper aux navigateurs sans unités de container query.
   */
  const UGC_STORIES_POLL_INTERVAL = 200;
  const UGC_STORIES_POLL_TIMEOUT = 120000;
  const UGC_STORIES_SUPPORTS_CQW = typeof CSS !== 'undefined' && CSS.supports('width', '1cqw');

  /*
   * Les styles de la section n'atteignent pas le shadow DOM du widget : on y
   * injecte une feuille dédiée. Rien de structurel ici, le placement des cartes
   * reste piloté par les variables CSS de l'hôte.
   */
  function injectUgcStoriesShadowStyle(shadowRoot) {
    if (shadowRoot.querySelector('[js-ugc-stories-shadow-style]')) return;

    const style = document.createElement('style');
    style.setAttribute('js-ugc-stories-shadow-style', '');
    style.textContent = [
      // Flèches natives : ce sont celles du thème qui pilotent la liste.
      '.join-carousel-button { display: none !important; }',
      // Titre optionnel du widget : la section a son propre heading.
      '.join-list-title { display: none !important; }',
      // Liste toujours calée à gauche (Join la centre quand elle ne déborde pas) et
      // cartes accrochées au bord au défilement, comme les tuiles de la section "UGC".
      // La dernière s'accroche par sa fin : la position de fin de liste est un vrai
      // point d'accroche, la dernière carte est donc toujours atteignable en entier.
      '.join-widget-list { margin-inline: 0 !important; scroll-snap-type: x mandatory; scroll-padding-inline: 10px; }',
      '.join-widget-element { scroll-snap-align: start; }',
      '.join-widget-element:last-child { scroll-snap-align: end; }',
    ].join('\n');
    shadowRoot.append(style);
  }

  function initUgcStories(section) {
    const host = section.querySelector('[js-ugc-stories-widget]');
    if (!host || section.dataset.ugcStoriesInit) return;

    section.dataset.ugcStoriesInit = 'true';

    const wrapper = section.querySelector('[js-ugc-stories-wrapper]');
    const controls = section.querySelector('[js-ugc-stories-controls]');
    const prevButton = controls?.querySelector('[js-ugc-stories-prev]');
    const nextButton = controls?.querySelector('[js-ugc-stories-next]');
    const currentSlideEl = controls?.querySelector('[js-ugc-stories-current]');
    const totalEl = controls?.querySelector('[js-ugc-stories-total]');

    // Join peut recréer sa liste (changement de plateforme, rechargement des
    // stories) : on la re-cherche à chaque fois plutôt que de la mémoriser.
    const getList = () => host.shadowRoot?.querySelector('.join-widget-list') ?? null;
    const getCells = (list) => Array.from(list.querySelectorAll('.join-widget-element'));
    const getMaxScroll = (list) => Math.max(0, list.scrollWidth - list.clientWidth);

    // Indices (0-based) de la première et de la dernière carte entièrement visibles,
    // ou null si aucune ne l'est (en cours de défilement animé).
    const getVisibleRange = (list, cells) => {
      const listRect = list.getBoundingClientRect();
      const styles = getComputedStyle(list);
      const start = listRect.left + (parseFloat(styles.paddingLeft) || 0);
      // L'hôte déborde du wrapper de son padding : on s'arrête au bord du viewport.
      const end = Math.min(
        listRect.right - (parseFloat(styles.paddingRight) || 0),
        document.documentElement.clientWidth
      );

      let first = -1;
      let last = -1;

      cells.forEach((cell, index) => {
        const rect = (cell.querySelector('.join-card-container') || cell).getBoundingClientRect();
        if (rect.left < start - 1 || rect.right > end + 1) return;

        if (first === -1) first = index;
        last = index;
      });

      return first === -1 ? null : { first, last };
    };

    const updateControls = () => {
      if (!controls) return;

      const list = getList();
      const cells = list ? getCells(list) : [];
      const maxScroll = list ? getMaxScroll(list) : 0;

      // Rien à faire défiler : widget pas encore monté, ou toutes les stories tiennent dans la vue.
      controls.hidden = maxScroll <= 1;
      if (!list) return;

      const scrollLeft = Math.round(list.scrollLeft);
      prevButton.disabled = scrollLeft <= 1;
      nextButton.disabled = scrollLeft >= Math.round(maxScroll) - 1;
      totalEl.textContent = String(cells.length);

      // Plage visible ("4–6") plutôt que la seule première carte : en fin de liste
      // le compteur atteint le total, et il dit ce que l'on voit réellement.
      const range = getVisibleRange(list, cells);
      if (!range) return;

      currentSlideEl.textContent =
        range.first === range.last ? String(range.first + 1) : `${range.first + 1}–${range.last + 1}`;
    };

    let updateScheduled = false;
    const scheduleUpdate = () => {
      if (updateScheduled) return;

      updateScheduled = true;
      requestAnimationFrame(() => {
        updateScheduled = false;
        updateControls();
      });
    };

    const scrollByStep = (direction) => {
      const list = getList();
      const cell = list?.querySelector('.join-widget-element');
      if (!list || !cell) return;

      const step = cell.getBoundingClientRect().width;
      const target = Math.min(Math.max(0, list.scrollLeft + step * direction), getMaxScroll(list));

      list.scrollTo({ left: target, behavior: 'smooth' });
    };

    prevButton?.addEventListener('click', () => scrollByStep(-1));
    nextButton?.addEventListener('click', () => scrollByStep(1));

    const onWidgetMounted = (shadowRoot) => {
      injectUgcStoriesShadowStyle(shadowRoot);

      // `scroll` ne remonte pas mais traverse la phase de capture : écouté sur le
      // shadow root, il suit la liste même si Join la remplace.
      shadowRoot.addEventListener('scroll', scheduleUpdate, { capture: true, passive: true });
      shadowRoot.addEventListener('scrollend', scheduleUpdate, { capture: true });
      // Cartes ajoutées, classes can-scroll-* posées par Join, re-render.
      new MutationObserver(scheduleUpdate).observe(shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
      new ResizeObserver(scheduleUpdate).observe(host);

      updateControls();
    };

    // Le widget se monte de façon asynchrone (script Join différé + fetch des
    // stories) sans émettre d'événement : on sonde jusqu'à l'apparition de sa liste.
    const start = performance.now();
    const waitForWidget = () => {
      const shadowRoot = host.shadowRoot;

      if (shadowRoot?.querySelector('.join-widget-list')) {
        onWidgetMounted(shadowRoot);
        return;
      }

      if (!section.isConnected || performance.now() - start > UGC_STORIES_POLL_TIMEOUT) return;
      setTimeout(waitForWidget, UGC_STORIES_POLL_INTERVAL);
    };

    waitForWidget();

    // Repli pour les navigateurs sans unités de container query (Safari < 16,
    // Chrome < 105, Firefox < 110) : la largeur du wrapper est fournie en px.
    if (!UGC_STORIES_SUPPORTS_CQW && wrapper) {
      const applyContainerWidth = () => {
        const styles = getComputedStyle(wrapper);
        const width =
          wrapper.clientWidth -
          (parseFloat(styles.paddingLeft) || 0) -
          (parseFloat(styles.paddingRight) || 0);

        host.style.setProperty('--ugc-stories-container-width', `${Math.max(0, width)}px`);
      };

      applyContainerWidth();
      new ResizeObserver(applyContainerWidth).observe(wrapper);
    }
  }

  function initUgcStoriesSections(root = document) {
    root.querySelectorAll('[js-ugc-stories]').forEach(initUgcStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUgcStoriesSections());
  } else {
    initUgcStoriesSections();
  }

  document.addEventListener('shopify:section:load', (event) => initUgcStoriesSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('ugc-block')) {
    class UgcBlock extends HTMLElement {
      #videoMedia;

      connectedCallback() {
        this.#videoMedia = this.querySelector('video-media');
        this.bindVideoListener();
        this.bindTouchRevealListener();
      }

      play() {
        if (!this.#videoMedia) return;

        this.#videoMedia.setAttribute('loaded', '');
        this.#videoMedia.play();
      }

      pause() {
        if (!this.#videoMedia) return;

        this.#videoMedia.pause();
        this.#videoMedia.removeAttribute('loaded');
        this.#videoMedia.removeAttribute('playing');
      }

      bindVideoListener() {
        if (!this.#videoMedia) return;

        this.#videoMedia.addEventListener('click', (event) => {
          event.preventDefault();
          this.#videoMedia.playing ? this.pause() : this.play();
        });
      }

      bindTouchRevealListener() {
        const product = this.querySelector('[js-ugc-product]');
        if (!product) return;

        product.addEventListener('click', (event) => {
          if (!window.matchMedia('(hover: none)').matches) return;

          const link = event.target.closest('[data-ugc-product-link]');
          const isProductAnchor =
            event.target instanceof HTMLAnchorElement &&
            product.contains(event.target);

          if (this.classList.contains('is-revealed') && (link || isProductAnchor))
            return;
          if (this.classList.contains('is-revealed')) return;

          event.preventDefault();

          this.closest('[js-ugc-carousel]')
            ?.querySelectorAll('[js-ugc-block].is-revealed')
            .forEach((block) => block.classList.remove('is-revealed'));

          this.classList.add('is-revealed');
        });
      }
    }

    window.customElements.define('ugc-block', UgcBlock);
  }

  function initUgcCarousel(section) {
    const carousel = section.querySelector('[js-ugc-carousel]');
    if (!carousel || carousel.dataset.ugcNavInit) return;

    carousel.dataset.ugcNavInit = 'true';

    const prevBtn = section.querySelector('[js-ugc-prev]');
    const nextBtn = section.querySelector('[js-ugc-next]');
    const cells = () => Array.from(carousel.querySelectorAll('[js-ugc-block]'));
    const currentSlideEl = section.querySelector('[current-slide-index]');

    const getLeadingIndex = () => {
      const items = cells();
      if (!items.length) return 0;

      const viewportLeft = carousel.getBoundingClientRect().left;

      return items.reduce((leading, cell, index) => {
        const distance = Math.abs(cell.getBoundingClientRect().left - viewportLeft);
        const leadingDistance = Math.abs(
          items[leading].getBoundingClientRect().left - viewportLeft
        );
        return distance < leadingDistance ? index : leading;
      }, 0);
    };

    const updateIndicator = () => {
      if (!currentSlideEl) return;
      currentSlideEl.textContent = String(getLeadingIndex() + 1);
    };

    const getStep = () => {
      const cell = carousel.querySelector('[js-ugc-block]');
      if (!cell) return 0;

      const gap = parseFloat(getComputedStyle(carousel).columnGap) || 0;
      return cell.offsetWidth + gap;
    };

    const maxScroll = () => Math.max(0, carousel.scrollWidth - carousel.clientWidth);

    const updateButtons = () => {
      const scrollLeft = Math.round(carousel.scrollLeft);
      const end = Math.round(maxScroll());

      if (prevBtn) prevBtn.disabled = scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = scrollLeft >= end - 1;
    };

    const scrollByStep = (direction) => {
      const step = getStep();
      if (!step) return;

      const target = Math.min(
        Math.max(0, carousel.scrollLeft + step * direction),
        maxScroll()
      );

      carousel.scrollTo({ left: target, behavior: 'smooth' });
    };

    prevBtn?.addEventListener('click', () => scrollByStep(-1));
    nextBtn?.addEventListener('click', () => scrollByStep(1));
    carousel.addEventListener('scroll', updateButtons, { passive: true });
    carousel.addEventListener('scroll', () => requestAnimationFrame(updateIndicator), {
      passive: true,
    });
    carousel.addEventListener('scrollend', () => {
      updateButtons();
      requestAnimationFrame(() => requestAnimationFrame(updateIndicator));
    });

    new ResizeObserver(() => {
      carousel.scrollLeft = Math.min(carousel.scrollLeft, maxScroll());
      updateButtons();
    }).observe(carousel);

    requestAnimationFrame(() => {
      carousel.scrollLeft = 0;
      updateButtons();
      updateIndicator();
    });
  }

  function initUgcCarousels(root = document) {
    root.querySelectorAll('.ugc').forEach(initUgcCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initUgcCarousels());
  document.addEventListener('shopify:section:load', (event) => initUgcCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
